import { commonHelper } from "helpers"
import { BILLING_CURRENCY } from "consts"

export const getCurrency = () => {
  return commonHelper.currency.getCurrency(BILLING_CURRENCY)
}
